import { TypoSmall } from "../text/Typo";
import { Box } from "../box/Box";

export interface IInfoButtonProps {
	text: string;
}

export const InfoButton = (_props: IInfoButtonProps) => {
	return (
		<Box sx={{ display: "flex", marginLeft: "auto", borderRadius: "50%", height: "100%", aspectRatio: "1 / 1", border: "1px solid #acacac", cursor: "pointer" }}>
			<TypoSmall sx={{ padding: "6px", userSelect: "none", color: "#777777", lineHeight: "0px", display: "flex", alignItems: "center", justifyContent: "center" }}>
				?
			</TypoSmall>
		</Box>
	);
};
